import AxiosClient from "../../../services/axios.services";

class ObjectiveMetricServices {
  getObjectiveMetric = (params) =>
    AxiosClient.get("/api/app/evaluacion_objetivos_metricas/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );
  getObjectiveMetricById = (id) =>
    AxiosClient.get(`/api/app/evaluacion_objetivos_metricas/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  saveObjectiveMetric = (data) =>
    AxiosClient.post("/api/app/evaluacion_objetivos_metricas/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  editObjectiveMetric = (id, data) =>
    AxiosClient.put(`/api/app/evaluacion_objetivos_metricas/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteObjectiveMetric = (id) =>
    AxiosClient.delete(`/api/app/evaluacion_objetivos_metricas/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
}

export default new ObjectiveMetricServices();
